import React, { createContext, useState, useEffect } from 'react';
import auth from '../utils/auth';
import localCart from '../utils/localCartStorage';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cartCount, setCartCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const handleAuthChange = async (event) => {
            if (event.detail?.type === 'login') {
                setIsLoading(true);
                await localCart.mergeWithServerCart();
                fetchCartCount();
                setIsLoading(false);
            } else if (event.detail?.type === 'logout') {
                setCartCount(0);
            }
        };

        document.addEventListener('authStateChange', handleAuthChange);

        if (auth.isAuthenticated()) {
            fetchCartCount();
        } else {
            setCartCount(localCart.getCartCount());
        }

        return () => {
            document.removeEventListener('authStateChange', handleAuthChange);
        };
    }, []);

    const fetchCartCount = async () => {
        if (auth.isAuthenticated()) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/cart`, {
                    headers: {
                        'Authorization': `Bearer ${auth.getToken()}`
                    }
                });
                if (response.ok) {
                    const data = await response.json();
                    setCartCount(data.items.reduce((total, item) => total + item.quantity, 0));
                }
            } catch (error) {
                console.error('Error fetching cart count:', error);
            }
        } else {
            setCartCount(localCart.getCartCount());
        }
    };

    const updateCartCount = (count) => {
        setCartCount(count);
    };

    return (
        <CartContext.Provider value={{ cartCount, updateCartCount, fetchCartCount, isLoading }}>
            {children}
        </CartContext.Provider>
    );
};